// extracted by mini-css-extract-plugin
module.exports = {"cursor":"BrushCursor_cursor__1uGnG","angle":"BrushCursor_angle__2yYtY","hardness":"BrushCursor_hardness__PQcxP","dot":"BrushCursor_dot__3aMMX"};